export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-ce097d7edde3e8153f514bce6f74c159.woff";